import { jsx as l } from "react/jsx-runtime";
const n = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M9.667 3.363H3.144l7.274 9.723-7.455 8.05h2.849l5.879-6.348 4.75 6.348h6.522L15.3 10.891l6.97-7.528H19.42L14.026 9.19zm7.822 15.68L7.326 5.456h1.292L18.78 19.042z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  n as default
};
